import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { EditUserProfileComponent } from './profile/edit-user-profile/edit-user-profile.component';
import { UserProfileComponent } from './profile/user-profile/user-profile.component';
import { UserHistoryComponent } from './search/user-history/user-history.component';
import { ContactListComponent } from './contact-list/contact-list.component';
import { SsoComponent } from './sso/sso/sso.component';
import { MsalGuard } from '@azure/msal-angular';
import { DirectreportComponent } from './directreport/directreport.component';
import { DeptempschedulereportComponent } from './deptempschedulereport/deptempschedulereport.component';
import { PhonelistreportComponent } from './phonelistreport/phonelistreport.component';
import { AdminpanelComponent } from './adminpanel/adminpanel.component';

const routes: Routes = [
  {path: '', redirectTo: '/user-hist', pathMatch: 'full' },
  {path: 'sso', component: SsoComponent, canActivate: [MsalGuard] },
  {path: 'my-profile', component: UserProfileComponent, canActivate: [MsalGuard] },
  {path: 'user-profile', component: UserProfileComponent, canActivate: [MsalGuard]},
  {path: 'edit-my-profile', component: EditUserProfileComponent, canActivate: [MsalGuard]},
  {path: 'edit-user-profile', component: EditUserProfileComponent, canActivate: [MsalGuard]},
  {path: 'user-hist', component: UserHistoryComponent, canActivate: [MsalGuard]},
  {path: 'contact-list', component:ContactListComponent, canActivate: [MsalGuard] },
  {path: 'directreports', component:DirectreportComponent, canActivate: [MsalGuard] },
  {path: 'teleworkreports', component:DeptempschedulereportComponent, canActivate: [MsalGuard] },
  {path: 'phonelist', component:PhonelistreportComponent, canActivate: [MsalGuard] },
  {path: 'adminpanel', component:AdminpanelComponent, canActivate: [MsalGuard] }
  //{path: '**',  redirectTo: 'user-search', pathMatch: 'full' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
